import React from "react";

import { BrandMark } from "@javascript/components/BrandMark";
import { MarketingFooter } from "@javascript/components/MarketingFooter";

export default function ContactShow() {
  return (
    <>
      <section className="flex flex-1 items-center px-4 py-12 sm:px-6 sm:py-20">
        <div className="mx-auto w-full max-w-6xl rounded-2xl border bg-background p-6 shadow-sm sm:p-10">
          <BrandMark size="md" className="font-serif font-semibold text-foreground" />

          <div className="mt-10 max-w-2xl">
            <p className="text-sm font-medium text-primary">Contact & seller identity</p>
            <h1 className="mt-3 font-serif text-4xl font-semibold tracking-tight sm:text-5xl">
              A real person behind every invitation.
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
              Goldypaper is operated by Nadiar Syaripul, from Bandung, Indonesia — an independent software business, not an incorporated company. The person who writes back is the person who built it.
            </p>
          </div>

          <dl className="mt-10 max-w-3xl divide-y border-y">
            <div className="grid gap-1 py-5 sm:grid-cols-3 sm:gap-6">
              <dt className="text-sm font-medium text-muted-foreground">Trading name</dt>
              <dd className="sm:col-span-2">Goldypaper</dd>
            </div>
            <div className="grid gap-1 py-5 sm:grid-cols-3 sm:gap-6">
              <dt className="text-sm font-medium text-muted-foreground">Operated by</dt>
              <dd className="sm:col-span-2">Nadiar Syaripul</dd>
            </div>
            <div className="grid gap-1 py-5 sm:grid-cols-3 sm:gap-6">
              <dt className="text-sm font-medium text-muted-foreground">Location</dt>
              <dd className="sm:col-span-2">Bandung, Indonesia</dd>
            </div>
            <div className="grid gap-1 py-5 sm:grid-cols-3 sm:gap-6">
              <dt className="text-sm font-medium text-muted-foreground">Support</dt>
              <dd className="sm:col-span-2">
                <a
                  href="mailto:contact@goldypaper.com"
                  className="whitespace-nowrap font-medium text-primary underline decoration-primary/40 underline-offset-4 transition-colors hover:text-primary/80"
                >
                  contact@goldypaper.com
                </a>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  Write whenever you like. You will hear back within 3 business days — Monday to Friday, Indonesian public holidays aside.
                </p>
              </dd>
            </div>
          </dl>
        </div>
      </section>

      <MarketingFooter illustration={false} />
    </>
  );
}
